// Uebernimmt den Sitzungsstatus (verbleibende comdirect-Verbindung) aus einer
// Server-Antwort in den globalen Zustand fuer die Sitzungsanzeige in der
// Top-Navigation (Chat-Modus, Umbau 2026-07-26). x.was.setBrokerageSession
// wird von NavigationTop.js gesetzt - vor dessen erstem Render (o.ae.) ist es
// noch undefined, daher der Guard.
export default function applyBrokerageSession(x, content) {
	if (content && content.brokerageSession !== undefined && x.was.setBrokerageSession) {
		x.was.setBrokerageSession(content.brokerageSession);
	}
}
